import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { labPanels } from '../../data/site';
import { Eyebrow } from '../ui/Eyebrow';
export function LabsPreview() {
  return <section className="bg-cream-light" data-id="element-67" data-mp="2lfe7gr3vqkfz">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-68" data-mp="2lecswcnnnfti">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20" data-id="element-69" data-mp="2hech6zrxxiq5">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/11bca244-30a4-406a-be5b-563ba023cc92.jpg" alt="A Republic at-home lab collection kit laid out on a cream surface" className="aspect-[16/10] w-full object-cover" data-id="element-70" data-mp="2cg148g6cms3p" />

          <div data-id="element-71" data-mp="1yghwvpld3ksg">
            <Eyebrow className="text-brick" data-id="element-72" data-mp="1yh1grbukoj94">Labs & testing</Eyebrow>
            <h2 className="mt-4 font-serif text-4xl leading-[1.06] text-ink md:text-[3.25rem]" data-id="element-73" data-mp="pyky8bp1hw5">
              Treatment starts with numbers, not a questionnaire.
            </h2>
            <ul className="mt-10" data-id="element-74" data-mp="3ss6i29i6sjla">
              {labPanels.map(panel => <li key={panel.name} className="rule grid gap-2 py-5 sm:grid-cols-[auto_1fr] sm:gap-6" data-id="element-75" data-mp="2reibfsh6y8d1">
                  <span className="font-serif text-2xl text-brick" data-id="element-76" data-mp="2wctjpyru8at5">{panel.markers}</span>
                  <div data-id="element-77" data-mp="2igy72ao17vy7">
                    <h3 className="text-sm font-medium text-ink" data-id="element-78" data-mp="2ihhqxwx8suev">{panel.name}</h3>
                    <p className="mt-1 max-w-md text-sm leading-relaxed text-ink-soft" data-id="element-79" data-mp="2mh07yhly0lcf">
                      {panel.detail}
                    </p>
                  </div>
                </li>)}
            </ul>
            <Link to="/labs" className="group mt-8 inline-flex items-center gap-2 text-sm text-ink transition-colors duration-150 ease-republic hover:text-brick" data-id="element-80" data-mp="31dzcfwlhzy2o">
              Collect at home or at 2,100 partner sites
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-republic group-hover:translate-x-1" data-id="element-81" data-mp="3t3m438lt0p0q" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}